function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#E2E5E7;}\n\t.st1{fill:#B0B7BD;}\n\t.st2{fill:#CAD1D8;}\n\t.st3{fill:#576D7E;}\n\t.st4{fill:#FFFFFF;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "480,224 384,128 480,128 "
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16V416z"
});

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M103.9,339.1c0-24.7,15.5-45.9,44.9-45.9c11.1,0,20,3.3,29.3,11.4c3.5,3.2,3.8,8.8,0.4,12.4 c-3.5,3.1-8.7,2.7-11.8-0.4c-5.2-5.5-10.6-7-17.9-7c-19.7,0-29.2,14-29.2,29.6c0,15.9,9.3,30.4,29.2,30.4c7.3,0,14.1-3,20-8.2 c4-3.1,9.5-1.6,11.8,1.5c2,2.8,3.1,7.6-1.4,12c-9,8.3-19.7,10-30.3,10C117.9,384.9,103.9,363.8,103.9,339.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M195.7,314.7c2.9-24.8,40.4-29.3,58.1-15.7c8.7,7-0.5,18.2-8.2,12.5c-9.5-6-31-8.8-33.6,4.5 c-3.5,21,52.2,9,51.3,43c-0.9,32.5-48,33.3-65.6,18.7c-4.2-3.4-4.1-9.1-1.8-12.5c3.3-3.3,7-4.5,11.4-0.9 c10.5,7.2,37.5,12.5,39.4-5.6C245,339.6,191.7,351,195.7,314.7z"
}));

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M301.5,380l-33.8-70.8c-5-10.1,10.1-18.4,15.7-7.8l11.4,25.7l14.7,33.8l14.4-33.8l11.4-25.7 c5.1-9.7,20-3.6,15.6,7L318.4,380C315.4,388.1,306.3,390,301.5,380z"
});

var SvgCsv = function SvgCsv(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCsv, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/csv.909d2517.svg";
export { ForwardRef as ReactComponent };